export default __webpack_public_path__ + "static/media/img1.00d753c9.jpg";